export default __webpack_public_path__ + "static/events-light-ab6ccd3d5b45db24592e64cf8dbcec49.png";